import { MaintenanceForwardingsDirectiveEntryKlass } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.type'
import {
  MaintenanceForwardingData,
  MaintenanceForwardingDirectiveEntryMap,
} from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceForwarding.type'
import { MaintenanceWorkflowData } from '@/features/maintenanceWorkflow/types/maintenanceWorkflows.type'
import { createContext, useContext } from 'react'

export const ForwardingTabContext = createContext<{
  workflow: MaintenanceWorkflowData | undefined
  forwarding:
    | MaintenanceForwardingData<MaintenanceForwardingDirectiveEntryMap[MaintenanceForwardingsDirectiveEntryKlass]>
    | undefined
  forwardingUpdatedAt: number
  directiveEntryKlass: MaintenanceForwardingsDirectiveEntryKlass | undefined
}>({
  workflow: undefined,
  forwarding: undefined,
  forwardingUpdatedAt: 0,
  directiveEntryKlass: undefined,
})

export const useForwardingTabContext = <DirectiveEntry extends MaintenanceForwardingsDirectiveEntryKlass>() =>
  useContext(ForwardingTabContext) as {
    workflow: MaintenanceWorkflowData | undefined
    forwarding: MaintenanceForwardingData<MaintenanceForwardingDirectiveEntryMap[DirectiveEntry]>
    forwardingUpdatedAt: number
    directiveEntryKlass: DirectiveEntry
  }
